// write configuration
const config = {
  gaKey: "G-TT3TKX1G9C",
  lineApiBaseUrl: "https://api.line.me/oauth2/v2.1",
  lineCheckFreindShipApiUrl: "https://api.line.me/friendship/v1/status",
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
  lineAddFriendApiUrl: "https://line.me/R",
  redirectUri: process.env.VUE_APP_REDIRECT_URI,
  clientId: process.env.VUE_APP_CLIENT_ID,
  lineId: process.env.VUE_APP_LINE_ID,
  // googleSheetId: process.env.VUE_APP_GOOGLE_SHEET_ID,
  googleSheetKey: process.env.VUE_APP_GOOGLE_SHEET_KEY,
  googleSheetBaseUrl: "https://sheets.googleapis.com/v4/spreadsheets/",
};

export default config;
